import { Box, SxProps, useTheme } from '@mui/material';

interface Props {
  icon: React.ReactNode;
  sx?: SxProps;
  showClickableCursor?: boolean;
  handleOnClick?: () => void;
  dark?: boolean;
}

const MapIconStyleWrapper: React.FC<Props> = ({
  icon,
  sx = {},
  showClickableCursor = false,
  handleOnClick,
  dark = true,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        ...sx,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: dark
          ? theme.colors.darkTheme.grey.medium
          : theme.colors.common.softWhite,
        color: theme.colors.common.white,
        borderRadius: theme.borderRadius.primary,
        p: '0.6rem',
        cursor: showClickableCursor ? 'pointer' : 'default',
      }}
      onClick={handleOnClick}
    >
      {icon}
    </Box>
  );
};

export default MapIconStyleWrapper;
